import React from 'react';

import cn from 'classnames';

import {
    IRequestMaterialSinglePosition,
    IRequestMaterialStage,
    RequestMaterialStage,
    useGetEstimateSupplyRequestPositionList,
} from '@entities/requestMaterial';
import { filterStages } from '@features/AddRequestMaterialModal/lib/filterStages';
import { MANUAL_STAGE_TITLE } from '@features/AddRequestMaterialModal/model';
import { EmptyBody } from '@features/AddRequestMaterialModal/ui';

import cls from './RequestsTableBody.module.css';

interface RequestsTableBodyProps {
    search: string;
    manualPositions: IRequestMaterialSinglePosition[];
    classes?: string;
}

export const RequestsTableBody = ({ search, manualPositions, classes }: RequestsTableBodyProps) => {
    const { isFetching, data: stages = [] } = useGetEstimateSupplyRequestPositionList();

    const manualStage: IRequestMaterialStage | null =
        manualPositions.length > 0
            ? { title: MANUAL_STAGE_TITLE, positions: manualPositions }
            : null;

    const mergedStages = manualStage ? [manualStage, ...stages] : stages;
    const filteredStages = filterStages(mergedStages, search);

    if (!isFetching && !filteredStages.length) {
        return <EmptyBody />;
    }

    return (
        <div className={cn(cls.RequestsTableBody, classes)}>
            {filteredStages.map((stage, index) => (
                <RequestMaterialStage stage={stage} key={stage.title + index} />
            ))}
        </div>
    );
};
